import ProfileEdit from "../components/Profile/ProfileEdit";

const ThemePage = () => {
    return (
        <ProfileEdit />
    )
}

export default ThemePage